import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-narrow-down', 'ArrowNarrowDown', [["path",{"d":"M12 5l0 14"}],["path",{"d":"M16 15l-4 4"}],["path",{"d":"M8 15l4 4"}]]);